import { UserInvitesParams } from './useUserInvitesQuery';
import { CustomerUsageQueryParams, UserSearchParams } from './types';
import { UserListFilter } from 'lib/context';
import { IResellersWithCustomersParams } from './useGetResellerCustomerCounts';
import { CustomerListParams } from './customersQuery';

export const superAdminKeys = {
  reseller: () => ['RESELLER'],
  infinite_resellers: ({
    start,
    limit,
    search,
  }: {
    start?: number;
    limit: number;
    search: string;
  }) => ['INFINITE_RESELLERS', start, limit, search],
  single_reseller: (resellerId: number) => ['RESELLER', resellerId],
  customers: (id: string) => ['CUSTOMERS', id],
  infiniteCustomers: (params: CustomerListParams) => ['CUSTOMERS', params],
  all_customers: () => ['USERS'],
  users: (customerId: string, departmentId: string) => [
    'USERS',
    customerId,
    departmentId,
  ],
  user_search: (params: UserSearchParams) => ['USER_SEARCH', params],
  all_users: () => ['CUSTOMERS'],
  departments: (id: string) => ['DEPARTMENTS', id],
  reseller_departments: (
    id: string,
    search: string,
    isSetupComplete: boolean
  ) => ['RESELLLER_DEPARTMENTS', id, search, isSetupComplete],
  reseller_users: (id: string) => ['RESELLLER_DEPARTMENTS', id],
  all_invite_users: () => ['INVITE_USERS'],
  invite_users: (params?: UserInvitesParams) => ['INVITE_USERS', params],
  customer_usage: (params: CustomerUsageQueryParams) => [
    'CUSTOMER_USAGE',
    params,
  ],
  filtered_users_for_superadmin: (
    filter: UserListFilter = {} as UserListFilter
  ) => ['super-admin-users', filter],
  all_users_for_superadmin: () => ['super-admin-users'],
  reseller_customer_counts: (params: IResellersWithCustomersParams) => [
    'RESELLERS_CUSTOMER_COUNTS',
    params,
  ],
};
